export const ExpiredStockAdjustmentDetails = () => {
    return <div>Expired Stock Adjustment Details</div>;
};

ExpiredStockAdjustmentDetails.displayName = 'ExpiredStockAdjustmentDetails';
